import { render, staticRenderFns } from "./Backtogetraenke.vue?vue&type=template&id=06a09f84&scoped=true"
import script from "./Backtogetraenke.vue?vue&type=script&lang=js"
export * from "./Backtogetraenke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a09f84",
  null
  
)

export default component.exports